module.exports = __webpack_public_path__ + "static/media/btn_android_kr.7e76da81.png";